import { Input } from "antd";
import React from "react";

export const PrintCyclenderInput = ({
  input_number,
  set_value,
  values = [],
  alarm_Data,
  disabled,
  placeholder,
}) => {
  const handleChange = (index, event) => {
    const newValue = event.target.value;
    const numValue = parseFloat(newValue);
    if (numValue > alarm_Data?.max) {
      return;
    }
    const newInputs = Array.isArray(values) ? [...values] : [];
    newInputs[index] = newValue;
    set_value(newInputs);
  };

  const getColorBasedOnValue = (value) => {
    const numValue = parseFloat(value);
    switch (true) {
      case numValue < alarm_Data?.orange:
        return "green";
      case numValue >= alarm_Data?.orange && numValue < alarm_Data?.red:
        return "orange";
      case numValue >= alarm_Data?.red && numValue <= alarm_Data?.max:
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <>
      {Array.from({ length: input_number }, (_, index) => {
        const color = getColorBasedOnValue(values[index], alarm_Data);
        return (
          <input
            disabled={disabled}
            key={index}
            className="PrintCyclenderInput"
            placeholder={`${placeholder}-${index + 1}`}
            type="text"
            value={values[index] || ""}
            // onChange={(event) => handleChange(index, event)}
            onChange={(event) => {
              if (/^\d*$/.test(event.target.value)) {
                handleChange(index, event);
              }
            }}
            style={{
              borderColor: color,
              borderWidth: "1.5px",
              borderStyle: "solid",
              color: color,
            }}
          />
        );
      })}
    </>
  );
};

export const PrintMachinaryInput = ({ input_number, set_value, values = [] }) => {
  const handleChange = (index, event) => {
    const newValue = event.target.value;
    set_value(newValue);
  };
  return (
    <>
      {Array.from({ length: input_number }, (_, index) => {
        return (
          <Input
            key={index}
            value={values[index] || ""}
            placeholder={`Temp-${index + 1}`}
            onChange={(event) => handleChange(index, event)}
          />
        );
      })}
    </>
  );
};
